import {
  withTranslation,
} from 'react-i18next';

import ResultTileView from './ResultTileView';

const TranslatedComponent = withTranslation()(ResultTileView);

const Component = TranslatedComponent;

export default Component;
